<template>
  <div class="mb-5">
    <div>
      <div>
        <p class="lead text-muted m-0">{{ 'Summary' | translate }}</p>
        <h1 class="">
          {{ course.finalPrice | price(page.currency) }}
        </h1>
      </div>
      <div class="d-flex align-items-start mt-4">
        <div class="me-2" style="max-width: 80px">
          <img
            :data-src="imageUrl(course.cover_photo)"
            alt=""
            class="img-fluid lazyload"
          />
        </div>
        <div class="">
          <small>{{ course.title }}</small>
        </div>
        <div class="ms-auto text-nowrap">
          <div v-if="(course.is_free || course.allow_student_to_set_price) && !selectedOrderBumps">
            <small>
              {{ course.finalPrice | price(page.currency) }}
            </small>
          </div>
          <div v-else-if="course.is_free && selectedOrderBumps">
            <small>
              {{ 0 | price(page.currency) }}
            </small>
          </div>
          <div v-else-if="course.price_variants">
            <small>
              {{ course.subtotal | price(page.currency) }}
            </small>
          </div>
          <div v-else>
            <div v-if="priceDiff" class="text-end">
              <div>
                <small class="text-muted">
                  <del>
                    {{ course.price | price(page.currency) }}
                  </del>
                </small>
              </div>
              <div>
                <small>
                  <span v-if="course.multiple_licences">{{ pricePerLicence | price(page.currency) }}</span>
                  <span v-else>{{ course.current_price | price(page.currency) }}</span>
                </small>
              </div>
            </div>
            <div v-else>
              <small>
                {{ course.price | price(page.currency) }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <OrderBumps></OrderBumps>
      <MultipleLicences v-if="course.multiple_licences"></MultipleLicences>
      <div v-show="showPromoCodeField">
        <PromoCode class="mb-3"></PromoCode>
      </div>
      <div class="mt-4">
        <div class="d-flex">
          <div>
            {{ 'Subtotal' | translate }}
          </div>
          <div class="ms-auto">
            {{ course.subtotal | price(page.currency) }}
          </div>
        </div>
        <hr />
      </div>
      <div class="mt-3">
        <div class="d-flex align-items-center">
          <div v-if="priceDiff">
            {{ 'Discount' | translate }}
          </div>
          <div class="ms-auto text-muted" v-if="priceDiff">
            {{ priceDiff | price(page.currency) }}
          </div>
        </div>
        <hr v-if="priceDiff" />
      </div>
      <div class="d-flex">
        <div class="fw-bold">
          {{ 'Total' | translate }}
        </div>
        <div class="ms-auto h5 fw-bold mb-0">
          {{ course.finalPrice | price(page.currency) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import PromoCode from './../PromoCode'
import MultipleLicences from './MultipleLicences'
import OrderBumps from './OrderBumps'

export default {
  components: {
    PromoCode,
    MultipleLicences,
    OrderBumps,
  },
  filters: {
    price(value, currency) {
      return (value / 100).toLocaleString(document.documentElement.lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
      })
    },
  },
  computed: {
    selectedOrderBumps() {
      return this.$store.state.selectedOrderBumps.length
    },
    quantity() {
      return this.$store.state.quantity || 1
    },
    pricePerLicence() {
      return this.course.finalPrice / this.quantity
    },
    showPromoCodeField() {
      if (
        this.course.multiple_licences ||
        this.course.is_free ||
        this.course.allow_student_to_set_price
      ) {
        return false
      }
      let view = this.$store.state.view
      if (
        this.checkoutType === 'membership' &&
        this.$store.state.page.payment_provider === 'Stripe'
      ) {
        return false
      }
      if (this.student.email) {
        return this.$store.state.page.display_promo_code_field
      }
      if (view === 'register') {
        return this.$store.state.page.display_promo_code_field
      }
      return false
    },
    checkoutType() {
      return this.$store.state.checkoutType
    },
    student() {
      return this.$store.state.user
    },
    priceDiff() {
      let diff = this.course.finalPrice - this.course.subtotal
      if (diff < 0) {
        return diff
      }
      return 0
    },
    course() {
      return this.$store.getters.courseAfterPriceReductions
    },
    page() {
      return this.$store.state.page
    },
  },
  methods: {
    imageUrl(url) {
      if (url) {
        return `https://djceg34j53tq.cloudfront.net/${url}`
      }
      return 'https://placehold.co/1280x800/E1D4F1/ffffff'
    },
  },
}
</script>
